'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isObject = require('lodash/isObject');

var _isObject2 = _interopRequireDefault(_isObject);

var _isEmpty = require('lodash/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _merge = require('lodash/merge');

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var combineStyles = function combineStyles(style, overrideStyle) {
  if ((0, _isObject2.default)(overrideStyle) && !(0, _isEmpty2.default)(overrideStyle)) {
    return (0, _merge2.default)({}, style, overrideStyle);
  }

  return style;
};

exports.default = combineStyles;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/anchor-ui/internal/combine-styles.js
// module id = 11
// module chunks = 0